<template>
    <header id="header">
        <nav id="main-navigation" class="navbar navbar-light bg-white py-2 d-flex justify-content-center shadow-lg">
          <img :srcset="require(`../../assets/Header/Roll20-Logo.svg`)" :class="imgClasses" height="38" @click="onClick" alt="Roll20 Logo" />
        </nav>
    </header> 
</template>

<script>
import { computed } from "vue";
export default {
  setup() {
    const onClick = () => {
      return !window.in_discord ? window.location.assign(`${window.location.protocol}//${window.location.host.split('.').slice(1).join('.')}`) : false;
    }

    const imgClasses = computed(() => {
      let classes = ["navbar-brand-image"];
      if (!window.in_discord) {
        classes.push("cursor-pointer")
      }
      return classes;
    });

    return {
      onClick,
      imgClasses
    }
  },
};
</script>

<style lang="scss">
#header {
  z-index: 100;
  position: relative;
}
.cursor-pointer {
  cursor: pointer
}
</style>
